import { LOCALES } from 'fractals'

export const ALL_PROGRAMS = {
  [LOCALES.ru]: 'Все программы',
  [LOCALES.en]: 'All programs',
  [LOCALES.uz]: 'Barcha dasturlar',
  [LOCALES.kk]: 'Барлық бағдарламалар'
} as const
